module.exports = __webpack_public_path__ + "static/img/login-1.5415963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-1.png
// module id = +MUi
// module chunks = 7